import React, { useRef } from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Skeleton,
} from "@mui/material";
import {
  RateReview as FeedbackIcon,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import { useGetFeedbacksQuery } from "@/store/api/homepageApi";
import FeedbackCard from "./FeedbackCard";

const FeedbackSection = () => {
  const { data, isLoading, error } = useGetFeedbacksQuery();
  const feedbacks = data?.data || [];
  const scrollRef = useRef(null);

  if (error) return null;
  // if (!isLoading && feedbacks.length === 0) return null;

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <Paper
      sx={{
        // p: { xs: 2, sm: 3, md: 4 },
        mb: 3,
        // borderRadius: 4,
        // background: "white",
        // boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        backgroundColor: 'transparent',
        boxShadow: "none"
      }}
    >
      {/* Section Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 2.5,
              background:
                "linear-gradient(135deg, #7E57C2 0%, #512DA8 100%)",
              mr: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FeedbackIcon sx={{ color: "white", fontSize: 26 }} />
          </Box>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              fontWeight: 700,
              background:
                "linear-gradient(135deg, #7E57C2 0%, #512DA8 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            STUDENT FEEDBACK
          </Typography>
        </Box>

        {/* Scroll arrows */}
        {feedbacks.length > 3 && (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <IconButton
              onClick={() => scroll("left")}
              size="small"
              sx={{
                color: "#512DA8",
                border: "1px solid rgba(81,45,168,0.3)",
                "&:hover": { background: "rgba(81,45,168,0.08)" },
              }}
            >
              <ChevronLeft />
            </IconButton>
            <IconButton
              onClick={() => scroll("right")}
              size="small"
              sx={{
                color: "#512DA8",
                border: "1px solid rgba(81,45,168,0.3)",
                "&:hover": { background: "rgba(81,45,168,0.08)" },
              }}
            >
              <ChevronRight />
            </IconButton>
          </Box>
        )}
      </Box>

      {/* Feedback Cards - Horizontal scroll */}
      {isLoading ? (
        <Box sx={{ display: "flex", gap: 2 }}>
          {[1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              variant="rounded"
              width={280}
              height={240}
              sx={{ borderRadius: 3, flexShrink: 0 }}
            />
          ))}
        </Box>
      ) : (
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            gap: 2,
            overflowX: "auto",
            pb: 1,
            scrollSnapType: "x mandatory",
            "&::-webkit-scrollbar": {
              height: 6,
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: 3,
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(126,87,194,0.3)",
              borderRadius: 3,
              "&:hover": {
                background: "rgba(126,87,194,0.5)",
              },
            },
          }}
        >
          {feedbacks.map((feedback) => (
            <Box
              key={feedback._id}
              sx={{
                minWidth: { xs: 260, sm: 280 },
                maxWidth: { xs: 260, sm: 300 },
                scrollSnapAlign: "start",
                flexShrink: 0,
              }}
            >
              <FeedbackCard feedback={feedback} />
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
};

export default FeedbackSection;
